// extracted by mini-css-extract-plugin
export default {"emptyListPlaceholder":"style_emptyListPlaceholder__dOSo1","title":"style_title__EtLzE"};